import { action, computed, observable } from "mobx";

class NestStore {
  /**
   * @property {boolean}
   */
  @observable isLoading = false;

  /**
   * @property {boolean}
   */
  @observable isSaving = false;

  /**
   * @property {boolean}
   */
  @observable isDeleting = false;

  /**
   * @property {Object}
   */
  @observable pagination = {};

  /**
   * @property {Object}
   */
  @observable searchParams = {};

  /**
   * @property {string}
   */
  @observable errorMessage = "";

  /**
   * @property {Object}
   */
  @observable errorMessages = {};

  /**
   * @property {boolean}
   */
  @observable infiniteLoadMore = true;

  /**
   * @property {string}
   */
  @observable order = "desc";

  /**
   * @property {string}
   */
  @observable locale = "en";

  constructor() {
    this.pagination = {
      currentPage: 1,
      itemsPerPage: 10,
      total: 0,
      showingFrom: 0,
      showingTo: 0,
      totalPages: 0,
    };
  }

  @action
  processPagination(pagination) {
    const { offset, recordsFiltered, recordsTotal } = pagination;

    this.pagination.total = 0;
    this.pagination.showingFrom = 0;
    this.pagination.showingTo = 0;
    this.pagination.totalPages = 0;

    if (recordsFiltered > 0) {
      this.pagination.total = recordsTotal;
      this.pagination.showingFrom = offset + 1;
      this.pagination.showingTo = offset + recordsFiltered;
      this.pagination.totalPages = Math.ceil(recordsTotal / this.pagination.itemsPerPage);
    }
  }

  @computed
  get offset() {
    return (this.pagination.currentPage - 1) * this.pagination.itemsPerPage;
  }

  @action
  updateSearchParams(data) {
    // eslint-disable-next-line array-callback-return
    Object.keys(data).map(key => {
      if (typeof this.searchParams[key] !== "undefined") {
        this.searchParams[key] = data[key];
      }
    });
  }

  @action
  changeValue(name, value) {
    const parts = name.split(".");

    // It only supports names like below
    // Example guest.address.street
    // Example guest.firstName
    // Example cardholderName
    if (parts.length === 3) {
      this[parts[0]][parts[1]][parts[2]] = value;
    } else if (parts.length === 2) {
      this[parts[0]][parts[1]] = value;
    } else if (parts.length === 1) {
      this[parts[0]] = value;
    } else {
      throw new Error("The format of the name is wrong.");
    }
  }

  @action
  clearErrorMessages() {
    this.errorMessage = "";
    this.errorMessages = {};
  }

  @action
  setErrorMessages(error) {
    if (error.status === "fail") {
      this.errorMessages = error.message;
    } else {
      this.errorMessage = error.message;
    }
  }
}

export default NestStore;
